import { ASSETS, LINKS } from './shopData'

// Dark footer sitting on the storefront's bg-footer artwork, mirroring the
// live site's four-column layout.
export default function ShopFooter() {
  const columns = [
    {
      title: 'Company',
      links: [
        { label: 'Home', href: LINKS.home },
        { label: 'Merch', href: LINKS.collectionAll },
        { label: 'App', href: LINKS.app },
      ],
    },
    {
      title: 'Legal',
      links: [
        { label: 'Terms', href: LINKS.terms },
        { label: 'Privacy', href: LINKS.privacy },
        { label: 'Contact', href: LINKS.contact },
      ],
    },
    {
      title: 'Merch',
      links: [
        { label: 'All Products', href: LINKS.collectionAll },
        { label: 'Shop Mens', href: LINKS.collectionMens },
        { label: 'Shop Womens', href: LINKS.collectionWomens },
      ],
    },
    {
      title: 'Official Partners',
      links: [
        { label: 'LA Mad Drops (MLP)', href: LINKS.partner, external: true },
        { label: '@getyourdub (Instagram)', href: LINKS.instagram, external: true },
      ],
    },
  ]

  return (
    <footer
      className="relative bg-[#181521] bg-cover bg-center bg-no-repeat text-white"
      style={{ backgroundImage: `url('${ASSETS.bgFooter}')` }}
    >
      <div className="absolute inset-0 bg-[#181521]/70" />
      <div className="relative mx-auto max-w-6xl px-5 py-14 sm:px-8">
        <div className="grid grid-cols-2 gap-10 md:grid-cols-5">
          <div className="col-span-2 md:col-span-1">
            <img src={ASSETS.logoWhite} alt="dub" className="h-8 w-auto" />
          </div>
          {columns.map((col) => (
            <div key={col.title}>
              {/* Inline color: the design system's unlayered h3 rule paints
                  headings dark, which vanishes on the dark footer. */}
              <h3 className="mb-3 text-sm font-semibold" style={{ color: 'rgba(255,255,255,0.9)' }}>
                {col.title}
              </h3>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      {...(l.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                      className="text-sm text-white/60 transition-colors hover:text-white"
                    >
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 border-t border-white/10 pt-6">
          <p className="text-sm text-white/50">© 2026 dub. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
